<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      errorMessage: errorMessage$ | async,
      questionNumber: questionNumber$ | async,
      readOnly: readOnly$ | async,
    };
    as data
  ) {
    <div class="form-group question-container-inner" [formGroup]="questionForm">
      @if (isLoading) {
        <div class="overlay-loader">
          <div class="loader"></div>
        </div>
      }
      @if (!translateOption) {
        <lib-input-container
          [headLine]="
            question.translations?.list['headLine']
              | translate: data.activeLang : question.structure.headLine
          "
          [description]="
            question.translations?.list['description']
              | translate: data.activeLang : question.structure.description
          "
          [labelPrefix]="data.questionNumber"
          [label]="
            question.translations?.list['title']
              | translate: data.activeLang : question.title
          "
          [questionMarkText]="
            question.translations?.list['questionMarkText']
              | translate: data.activeLang : question.structure.questionMarkText
          "
          [required]="question.validation.required"
          [maxLength]="question.validation.maxLength"
          [errorText]="data.errorMessage"
          [currentLength]="value.value ? value.value.length : 0"
          [for]="labelPrefix + question.id"
          [helpText]="
            question.translations?.list['helpText']
              | translate: data.activeLang : question.structure.helpText
          "
        >
          @if (!data.readOnly) {
            <lib-dot-indicator
              type="text-input"
              [isVisible]="
                showChanges() &&
                previousAnswersService.hasTextareaValueChanged(
                  question.id,
                  repeaterGroupId,
                  value.value
                )
              "
            />
            <textarea
              vinnova-textarea
              [id]="labelPrefix + question.id"
              [error]="!!data.errorMessage"
              [required]="question.validation.required"
              formControlName="value"
              [placeholder]="question.structure.placeholder"
              [size]="size"
            ></textarea>
          }
          @if (data.readOnly) {
            <ng-container
              *ngTemplateOutlet="
                readonlyTemplate;
                context: {
                  value: readonly(),
                  error: data.errorMessage,
                }
              "
            ></ng-container>
          }
        </lib-input-container>
      }
      @if (translateOption) {
        <lib-input-container
          [label]="
            question.translations?.list['title']
              | translate: data.activeLang : question.title
          "
          [labelPrefix]="data.questionNumber"
          [headLine]="
            question.translations?.list['headLine']
              | translate: data.activeLang : question.structure.headLine
          "
          [description]="
            question.translations?.list['description']
              | translate: data.activeLang : question.structure.description
          "
          [required]="true"
        >
          @if (
            {
              errorMessageSwe: errorMessageSwe$ | async,
              errorMessageEng: errorMessageEng$ | async,
              swedishHelpText: swedishHelpText$ | async,
            };
            as translateData
          ) {
            <div class="form-group question-container-inner">
              <lib-input-container
                [label]="
                  question.translations?.list['swedishTitle']
                    | translate
                      : data.activeLang
                      : question.structure.swedishTitle
                "
                [required]="question.validation.required"
                [maxLength]="question.validation.maxLength"
                [errorText]="translateData.errorMessageSwe"
                [helpText]="translateData.swedishHelpText"
                [currentLength]="
                  valueSwedish.value ? valueSwedish.value.length : 0
                "
                [for]="labelPrefix + question.id + '_1'"
                [questionMarkText]="
                  question.translations?.list['questionMarkText']
                    | translate
                      : data.activeLang
                      : question.structure.questionMarkText
                "
                [helpText]="
                  question.translations?.list['helpText']
                    | translate: data.activeLang : question.structure.helpText
                "
              >
                @if (!data.readOnly) {
                  <lib-dot-indicator
                    type="text-input"
                    [isVisible]="
                      showChanges() &&
                      previousAnswersService.hasFieldChanged(
                        question.id,
                        repeaterGroupId,
                        'valueSwedish',
                        valueSwedish?.value
                      )
                    "
                  />
                  <textarea
                    vinnova-textarea
                    [id]="labelPrefix + question.id + '_1'"
                    [error]="!!translateData.errorMessageSwe"
                    [required]="question.validation.required"
                    [formControl]="valueSwedish"
                    [placeholder]="question.structure.placeholder"
                    [size]="size"
                  ></textarea>
                }
                @if (data.readOnly) {
                  <ng-container
                    *ngTemplateOutlet="
                      readonlyTemplate;
                      context: {
                        value: sweReadonly(),
                        error: translateData.errorMessageSwe,
                      }
                    "
                  ></ng-container>
                }
              </lib-input-container>
              @if (!data.readOnly) {
                <div>
                  <button
                    vinnova-button-secondary
                    [ngClass]="
                      question.structure.englishTitle ? 'englishTitle' : ''
                    "
                    size="small"
                    type="button"
                    (click)="
                      (valueEnglish.value?.trim().length ?? 0) > 0
                        ? translateModal(confirmTranslate)
                        : translateText()
                    "
                  >
                    {{ t('translate_button_text') }}
                  </button>
                </div>
              }
              <lib-input-container
                [label]="
                  question.translations?.list['englishTitle']
                    | translate
                      : data.activeLang
                      : question.structure.englishTitle
                "
                [required]="question.validation.required"
                [translated]="translatedHelpTextShow"
                [maxLength]="
                  question.validation.maxLength ? englishMaxLength : undefined
                "
                [errorText]="translateData.errorMessageEng"
                [currentLength]="
                  valueEnglish.value ? valueEnglish.value.length : 0
                "
                [for]="labelPrefix + question.id + '_2'"
                [questionMarkText]="
                  question.translations?.list['englishQuestionmarkText']
                    | translate
                      : data.activeLang
                      : question.structure.englishQuestionmarkText
                "
                [helpText]="
                  question.translations?.list['englishHelpText']
                    | translate
                      : data.activeLang
                      : question.structure.englishHelpText
                "
              >
                @if (translatedHelpTextShow) {
                  <span
                    class="text-translated-show"
                    [class.is-optional]="!question.validation.required"
                    >{{ t('machine_translated') }}</span
                  >
                }
                @if (!data.readOnly) {
                  <lib-dot-indicator
                    type="text-input"
                    [isVisible]="
                      showChanges() &&
                      previousAnswersService.hasFieldChanged(
                        question.id,
                        repeaterGroupId,
                        'valueEnglish',
                        valueEnglish?.value
                      )
                    "
                  />
                  <textarea
                    vinnova-textarea
                    class="english-value"
                    [class.machine-text]="styleFirstLine"
                    [id]="labelPrefix + question.id + '_2'"
                    [error]="!!translateData.errorMessageEng"
                    [required]="question.validation.required"
                    [formControl]="valueEnglish"
                    [class.translated]="translated"
                    (click)="translateToFalse()"
                    [placeholder]="question.structure.placeholder"
                    [size]="size"
                    (keydownOutput)="translateToFalse()"
                  ></textarea>
                }
                @if (data.readOnly) {
                  <ng-container
                    *ngTemplateOutlet="
                      readonlyTemplate;
                      context: {
                        value: engReadonly(),
                        error: translateData.errorMessageEng,
                      }
                    "
                  ></ng-container>
                }
              </lib-input-container>
            </div>
          }
        </lib-input-container>
      }
    </div>
    <ng-template #readonlyTemplate let-value="value" let-error="error">
      <div [ngClass]="error ? 'invalid' : ''">
        <div
          class="readonly"
          [ngClass]="
            value?.length < 700
              ? value?.length < 300
                ? 'small-height'
                : 'medium-height'
              : ''
          "
        >
          @if (value?.includes('machine translated')) {
            <span>
              {{ value.slice(0, 39) }}
              <br />
              {{ value.slice(39, value.length) }}
            </span>
          }
          @if (!value?.includes('machine translated')) {
            <span>
              {{ value }}
            </span>
          }
        </div>
      </div>
    </ng-template>
    <ng-template #confirmTranslate>
      <lib-modal
        [title]="t('translate_title')"
        [showCloseButton]="true"
        (closeModal)="confirmTranslateModal.hide()"
        [showSecondaryButton]="true"
        [showPrimaryButton]="true"
        [secondaryButtonText]="t('cancel_btn_form')"
        [primaryButtonText]="t('continue_btn')"
        (secondaryButton)="confirmTranslateModal.hide()"
        (primaryButton)="translateText(); confirmTranslateModal.hide()"
      >
        <div>
          <p>{{ t('translate_replace') }}</p>
          <p>{{ t('translate_text') }}</p>
        </div>
      </lib-modal>
    </ng-template>
  }
</ng-container>
